import React, { useState } from "react";
import { Row, Col, Spinner, Button } from "react-bootstrap";
import styled from "styled-components";
import CheckIcon from "@mui/icons-material/Check";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SuccessButton from "../../../organisms/SuccessButton";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { useMutation } from "@tanstack/react-query";
import { buildNuevaCompra, calcularTotalCompra, Model } from "../Model";
import ExitoCard, { ExitoOption } from "../../../organisms/ExitoCard";
import PaymentIcon from "@mui/icons-material/Payment";
import { comprar } from "../../../../services/comprasServicios";
import TableSection from "./TableSection";
import Pagar from "../Pagar/Pagar";
import { useWizard } from "../../../../hooks/wizard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SeleccionProductos from "../SeleccionProductos/SeleccionProductos";

function Confirmacion({ model }: { model: Model }) {
  const [newModel, setNewModel] = useState(model);
  const { avanza, avanzar, vuelve, volver } = useWizard();
  const [termino, setTermino] = useState(false);

  const {
    error: errorMutacionComprar,
    isLoading: mutacionIsLoading,
    mutate,
  } = useMutation(comprar, {
    onSuccess: () => {
      setTermino(true);
    },
  });

  const error = errorMutacionComprar;

  const onProductoValorChange = (idProducto: string, valor: number) => {
    setNewModel((prev) => {
      let detallesNuevo = new Map(prev.detallesPorProducto);
      const detalle = detallesNuevo.get(idProducto)!;
      detallesNuevo.set(idProducto, { ...detalle, valor });
      return {
        ...prev,
        detallesPorProducto: detallesNuevo,
        total: calcularTotalCompra(Array.from(detallesNuevo.values())),
      };
    });
  };

  const onConfirmarClick = () => {
    const nuevaCompra = buildNuevaCompra(newModel);
    mutate(nuevaCompra);
  };

  if (termino) {
    return <ExitoCard title={"¡Compra exitosa!"} options={exitoOptions} />;
  }

  if (avanza) {
    return <Pagar model={newModel} />;
  }

  if (vuelve) {
    return <SeleccionProductos model={newModel} />;
  }

  return (
    <>
      {error && <ServerErrorModal />}
      <Row className="justify-content-center">
        <Col className="col-10">
          <section className="pt-5 mb-4">
            <h4>
              Resúmen de compra
              <IconContainer>
                <FactCheckIcon sx={{ fontSize: 28 }} />
              </IconContainer>
            </h4>
          </section>

          <section className="mb-4">
            <TableSection
              total={newModel.total}
              items={newModel.detallesPorProducto}
              onProductoValorChange={onProductoValorChange}
            />
          </section>

          <section className="d-flex justify-content-between">
            <Button onClick={volver}>
              <ArrowBackIcon sx={{ fontSize: 20 }} />
              Volver
            </Button>
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                onClick={avanzar}
                style={{ marginRight: "4px" }}
              >
                <PaymentIcon sx={{ fontSize: 18, marginRight: "2px" }} />
                Pagar
              </Button>
              <SuccessButton
                type={"button"}
                onClick={onConfirmarClick}
                variant="success"
              >
                {!mutacionIsLoading && (
                  <CheckIcon sx={{ fontSize: 18, marginRight: "2px" }} />
                )}
                {mutacionIsLoading && <Spinner animation="border" size="sm" />}
                Finalizar{" "}
              </SuccessButton>
            </div>
          </section>
        </Col>
      </Row>
    </>
  );
}

const IconContainer = styled("span")`
  display: relative;
  margin-left: 8px;
  color: ${(props) => props.theme.colors.main};
`;

const exitoOptions: ExitoOption[] = [
  {
    description: "Realizar nueva compra",
    path: "/compras/comprar",
    variant: "primary",
  },
];

export default Confirmacion;
